import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function NewsletterForm({ variant = "light" }) {
    const [email, setEmail] = useState("");
    const [firstName, setFirstName] = useState("");
    const [consent, setConsent] = useState(false);
    const [submitting, setSubmitting] = useState(false);

    const isDark = variant === "dark";

    const onSubmit = async (e) => {
        e.preventDefault();
        if (!email) {
            toast.error("Please enter your email address.");
            return;
        }
        if (!consent) {
            toast.error("Please confirm consent to subscribe.");
            return;
        }
        setSubmitting(true);
        try {
            const res = await axios.post(`${API}/newsletter`, {
                email,
                first_name: firstName || null,
                consent,
            });
            toast.success(res.data?.message || "Thanks for subscribing.");
            setEmail("");
            setFirstName("");
            setConsent(false);
        } catch (err) {
            const msg = err?.response?.data?.detail || "Something went wrong. Please try again.";
            toast.error(typeof msg === "string" ? msg : "Subscription failed.");
        } finally {
            setSubmitting(false);
        }
    };

    const inputClass = isDark
        ? "w-full bg-transparent border border-offwhite/30 focus:border-offwhite text-offwhite placeholder:text-offwhite/50 px-4 py-3 text-sm outline-none transition-colors"
        : "cap-input";

    return (
        <form onSubmit={onSubmit} className="space-y-3" data-testid="newsletter-form">
            <input
                type="text"
                placeholder="First name (optional)"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                className={inputClass}
                data-testid="newsletter-first-name-input"
            />
            <input
                type="email"
                required
                placeholder="Email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className={inputClass}
                data-testid="newsletter-email-input"
            />
            <label
                className={`flex items-start gap-3 text-xs leading-relaxed ${
                    isDark ? "text-offwhite/70" : "text-slate"
                }`}
            >
                <input
                    type="checkbox"
                    checked={consent}
                    onChange={(e) => setConsent(e.target.checked)}
                    className="mt-0.5 h-4 w-4 accent-teal"
                    data-testid="newsletter-consent-checkbox"
                />
                <span>
                    I agree to receive occasional insights from Chief AI Partners. Unsubscribe at any time.
                </span>
            </label>
            <button
                type="submit"
                disabled={submitting}
                data-testid="newsletter-submit-btn"
                className={
                    isDark
                        ? "w-full inline-flex items-center justify-center bg-offwhite text-navy font-semibold px-5 py-3 text-sm tracking-wide hover:bg-sand transition-colors disabled:opacity-60"
                        : "cap-btn-primary w-full"
                }
            >
                {submitting ? "Submitting..." : "Subscribe"}
            </button>
        </form>
    );
}
